import { Flex } from "@/base/components/index";
import { usePageTableStyles } from "./data-table.styles";
import { useBreakpoint } from "@/base/utils/index";
import { useContextDataTable } from "../context/index";

export const DataTableHeader = () => {
  const screens = useBreakpoint();
  const { styles } = usePageTableStyles();
  const { header } = useContextDataTable();

  if (!header) {
    return null;
  }

  return (
    <Flex
      gap={12}
      vertical={!screens.md}
      justify="space-between"
      className={styles.header}
    >
      {header}
    </Flex>
  );
};
